module.exports = __webpack_public_path__ + "media/images/sauna-27fd12cda8f3323b02fa188d7a8bea6e.svg";